var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.988,
    height: 17.579,
    viewBox: "0 0 19.988 17.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 19.988,
    height: 17.579,
    fill: "#e30613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_128",
    "data-name": "Groupe 128",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_127",
    "data-name": "Groupe 127",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M3.922,2.079V0H2.577V2.079a3.249,3.249,0,0,0,0,6.357v9.142H3.923V8.436a3.249,3.249,0,0,0,0-6.357M3.249,7.162a1.9,1.9,0,1,1,1.9-1.9,1.906,1.906,0,0,1-1.9,1.9",
    transform: "translate(0 0)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_102",
    "data-name": "Trac\\xE9 102",
    d: "M23.74,9.142V0H22.394V9.142a3.249,3.249,0,0,0,0,6.358v2.079h1.346V15.5a3.249,3.249,0,0,0,0-6.358m-.673,5.082a1.9,1.9,0,1,1,1.9-1.9,1.906,1.906,0,0,1-1.9,1.9",
    transform: "translate(-13.073 0)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M46.134,6.579A3.255,3.255,0,0,0,43.557,3.4V0H42.211V3.4a3.249,3.249,0,0,0,0,6.357v7.821h1.346V9.758a3.255,3.255,0,0,0,2.577-3.179m-3.25,1.9a1.9,1.9,0,1,1,1.9-1.9,1.906,1.906,0,0,1-1.9,1.9",
    transform: "translate(-26.146 0)",
    fill: "#e30613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTools);
export default __webpack_public_path__ + "static/media/icon-tools.f2e2ef6f90395d86888f3aa2db93fbb6.svg";
export { ForwardRef as ReactComponent };